import {
  useWindowSize,
  useCssVar,
} from '@vueuse/core';
import { watch } from 'vue';

export function useVisualViewportHeight () {
  const { height } = useWindowSize({
    type: 'visual',
  });

  const cssVar = useCssVar('--vvh', document.documentElement);

  watch(height, (newVal) => {
    cssVar.value = `${String(newVal)}px`;
  }, { immediate: true });
}
